<app-dialog-header (backClick)="onNoClick()" [header]="log.log.message"></app-dialog-header>

<div class="dialog-view-wrapper">

    <h2 class="panel-title">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.LogInfo' | translate }}</h2>
    <div class="details-card">
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.timeStamp' | translate }}</h4>
            <div class="detail-value">{{ log.log.timeStampUtc | localizedDate: 'short' }}</div>
        </div>

        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.Message' | translate }}</h4>
            <div class="detail-value preserve-whitespace">{{ log.log.message }}</div>
        </div>
    </div>

    <h2 *ngIf="showUserData()" class="panel-title">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.User' | translate }}</h2>
    <div class="details-card" *ngIf="showUserData()">
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.Name' | translate }}</h4>
            <div class="detail-value">{{ log.log.user.name || ('General.NotAvailableShort' | translate) }}</div>
        </div>
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.Email' | translate }}</h4>
            <div class="detail-value">{{ log.log.user.email || ('General.NotAvailableShort' | translate) }}</div>
        </div>
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.UserId' | translate }}</h4>
            <div class="detail-value">{{ log.log.user.userId || ('General.NotAvailableShort' | translate) }}</div>
        </div>
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.CompanyName' | translate }}</h4>
            <div class="detail-value">{{ log.log.user.companyName || ('General.NotAvailableShort' | translate) }}</div>
        </div>
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.CompanyId' | translate }}</h4>
            <div class="detail-value">{{ log.log.user.companyId || ('General.NotAvailableShort' | translate) }}</div>
        </div>
    </div>

    <h2 *ngIf="showImpUserData()" class="panel-title">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.ImpUser' | translate }}</h2>
    <div class="details-card" *ngIf="showImpUserData()">
       <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.Name' | translate }}</h4>
            <div class="detail-value">{{ log.log.impUser.name || ('General.NotAvailableShort' | translate) }}</div>
        </div>
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.Email' | translate }}</h4>
            <div class="detail-value">{{ log.log.impUser.email || ('General.NotAvailableShort' | translate) }}</div>
        </div>
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.UserId' | translate }}</h4>
            <div class="detail-value">{{ log.log.impUser.userId || ('General.NotAvailableShort' | translate) }}</div>
        </div>
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.CompanyName' | translate }}</h4>
            <div class="detail-value">{{ log.log.impUser.companyName || ('General.NotAvailableShort' | translate) }}</div>
        </div>
        <div>
            <h4 class="detail-type">{{ 'Modules.XPACManagementComponent.XpacLoggingDetailsComponent.CompanyId' | translate }}</h4>
            <div class="detail-value">{{ log.log.impUser.companyId || ('General.NotAvailableShort' | translate) }}</div>
        </div>
    </div>

</div>